module.exports = __webpack_public_path__ + "9606d852132381b34f40218098003ca0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-300.woff2
// module id = 454
// module chunks = 0